export default function progressiveLoadBackgroundImage(enhancedClass, callback) {
  // Quit early if older browser (e.g. IE8).
  if (!('addEventListener' in window)) {
    return;
  }

  const img = new Image();
  const absolutePathPattern = /^http|https|http:|https:|\/\//;

  // Rather convoluted, but parses out the first mention of a background
  // image url for the enhanced header, even if the style is not applied.
  const bigSrc = (() => {
    const { styleSheets } = document;
    const styleSheetsLength = styleSheets.length;
    let bgDecl;

    for (let styleSheetsIndex = 0; styleSheetsIndex < styleSheetsLength; styleSheetsIndex += 1) {
      let styles = null;
      let styleUrl = null;
      try {
        styles = document.styleSheets[styleSheetsIndex].rules || document.styleSheets[styleSheetsIndex].cssRules;
        styleUrl = document.styleSheets[styleSheetsIndex].href;
      } catch (e) {
        // ignore.
      }
      if (!styles) {
        // eslint-disable-next-line no-continue
        continue;
      }

      // Fetch the background-image declaration...
      bgDecl = (() => {
        let bgStyle;
        const l = styles.length;
        for (let i = 0; i < l; i += 1) {
          if (styles[i].selectorText && styles[i].selectorText === `.${enhancedClass}`) {
            let imageUrl = styles[i].style.backgroundImage.match(/(?:\(['|"]?)(.*?)(?:['|"]?\))/)[1];
            if (!absolutePathPattern.test(imageUrl)) {
              let baseUrl = styleUrl.replace(/[^/]*$/, '');
              const pathBackCount = (imageUrl.match(/(\.\.\/)/g) || []).length;
              imageUrl = imageUrl.replace(/(\.\.\/)/g, '');

              for (let baseUrlIndex = 0; baseUrlIndex < pathBackCount; baseUrlIndex += 1) {
                baseUrl = baseUrl.replace(/([^/]*\/)$/, '');
              }

              imageUrl = baseUrl + imageUrl;
            }

            bgStyle = imageUrl;
            break;
          }
        }
        return bgStyle;
      })();

      if (bgDecl) {
        break;
      }
    }
    return bgDecl;
  })();

  img.onload = () => {
    callback();
  };

  if (bigSrc) {
    img.src = bigSrc;
  }
}
